import { SystemMessage } from '@aid/core/types/classes';

export interface ChatSystemMessage extends SystemMessage {
  receiverId: number;
  senderId: number;
}
